import { type FC } from "react";
import { generatePath } from "react-router-dom";

import { Breadcrumb } from "@snapchat/snap-design-system";

import { useFeatureGates } from "../../../cof-feature-gates/hooks";
import { AbsoluteRoute } from "../../../core/routes";
import { CofConfigId } from "../../../gql-generated/types";
import {
    useSelectedLensCentralOrganizationNotIncludesCamkitOrgs,
    useSelectedLensFolder,
    useSelectedLensFolderV3,
} from "../../../shared/hooks";
import { useSelectedOrganization } from "../../../shared/hooks/useSelectedOrganization";
import { LinkStyled } from "../../../shared/styles";

import { BreadcrumbItem, BreadcrumbItemContainer, breadcrumbContainer } from "./DetailsBreadcrumb.styles";

export const LensFoldersPageBreadcrumbs: FC = () => {
    const orgV1 = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();
    const folderV1 = useSelectedLensFolderV3();

    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;
    const orgV2 = useSelectedOrganization();
    const { lensFolder: folderV2 } = useSelectedLensFolder();

    const orgId = (isMyLensesOrgsV2Enabled ? orgV2?.id : orgV1?.id) ?? "";
    const orgName = (isMyLensesOrgsV2Enabled ? orgV2?.name : orgV1?.name) ?? "";
    const folderName = (isMyLensesOrgsV2Enabled ? folderV2?.name : folderV1?.name) ?? "";

    return (
        <div className={breadcrumbContainer}>
            <Breadcrumb>
                <Breadcrumb.Item>
                    <LinkStyled
                        to={generatePath(AbsoluteRoute.ORG_LENS_FOLDERS, {
                            orgId,
                        })}
                    >
                        <BreadcrumbItemContainer>
                            <BreadcrumbItem>{orgName}</BreadcrumbItem>
                        </BreadcrumbItemContainer>
                    </LinkStyled>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <BreadcrumbItemContainer>
                        <BreadcrumbItem active={true}>{folderName}</BreadcrumbItem>
                    </BreadcrumbItemContainer>
                </Breadcrumb.Item>
            </Breadcrumb>
        </div>
    );
};
